<div class="info-dialog-container">
  <div class="header">
    <div class="title">{{ title | translate }}</div>
  </div>
  <div class="content">
    {{ message | translate }}
  </div>
  <div class="footer">
    <div class="actions">
      <button class="confirmation-button" (click)="close()">{{ confirmActionLabel | translate }}</button>
    </div>
  </div>
</div>
